export default `<svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 1024 1024">
    <path d="M1023.999 186.182v791.273q0 19.549-13.964 33.047t-32.582 13.498h-139.636v-372.364h-651.636v372.364h-139.636q-19.549 0-33.047-13.498t-13.498-33.047v-930.909q0-18.619 13.498-32.582t33.047-13.964h232.727v279.273h465.455v-279.273h93.091zM651.635 0h-93.091v186.182h93.091v-186.182z"></path>
</svg>
`;
